import {TicketsService} from '@/services/tickets.service'

export default {
    AirportList({commit}) {

        return TicketsService.getAirportlist()
            .then(function (data) {
                if (typeof data.data !== 'undefined')
                    commit('SET_AIRPORT_LIST', data.data)
            })
            .catch(function (err) {
                console.log(err)

            })
    },
    Avaibles({commit}, payload) {
        return TicketsService.getAvaibles(payload.from, payload.to, payload.date)
            .then(function (data) {
                if (typeof data.data !== 'undefined')
                    commit('SET_AVAIBLES', data.data)
            })
            .catch(function (err) {
                console.log(err)

            })
    },
    Avaible15Days({commit}, payload) {
        return TicketsService.getAvaibles15Days(payload.from, payload.to)
            .then(function (data) {
                if (typeof data.data !== 'undefined')
                    commit('SET_AVAIBLE_15_DAYS', data.data)
            })
            .catch(function (err) {
                console.log(err)

            })
    },
    Captcha({commit},data) {
        return TicketsService.captcha(data).then(function (data) {
            commit('SET_CAPTCHA',data.data)
        })
            .catch(function (err) {
                console.log(err)
            })
    },
    Pay({commit},data) {
        return TicketsService.pay(data).then(function (data) {
            let info = data.data;
            return TicketsService.final_pay(info).then(function (final_data) {
                return final_data.data;
            })
        })
            .catch(function (err) {
                console.log(err)
            })
    }
}